import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import classes from './FinalQuizCard.module.scss'

const FinalQuizCard = ({ finalQuiz, selected, onSelect }) => {
  const { t } = useTranslation()
  const retakes = finalQuiz.maxAttempts
    ? t('certificationBuilder.curriculum.retakes', { count: finalQuiz.maxAttempts })
    : t('certificationBuilder.curriculum.retakesUnlimited')

  return (
    <button className={classNames('d-flex align-items-center text-left', classes.card, { [classes.cardSelected]: selected })} onClick={onSelect}>
      <span className={classNames('d-inline-flex align-items-center justify-content-center', classes.icon)}>
        <i className='fa fa-graduation-cap' aria-hidden='true' />
      </span>
      <span className={classes.text}>
        <span className={classes.title}>{t('certificationBuilder.curriculum.finalQuiz')}</span>
        <span className={classes.meta}>
          {t('certificationBuilder.curriculum.finalQuizMeta', { count: finalQuiz.questions.length, passMark: finalQuiz.passMark, retakes })}
        </span>
      </span>
      <span className={classes.edit}>{t('common.edit')}</span>
    </button>
  )
}

FinalQuizCard.propTypes = {
  finalQuiz: PropTypes.shape({
    passMark: PropTypes.number.isRequired,
    maxAttempts: PropTypes.number,
    questions: PropTypes.array.isRequired,
  }).isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
}

export default FinalQuizCard
